module.exports = __webpack_public_path__ + "img/A0103.c0f404b1.png";